import React from 'react'

const Jva_Dup = () => {
    return (
        <div className='container'>
            <h1>Remove duplicates from a given string</h1>
            <p>Given a string <strong>S</strong>, the task is to remove all the duplicates in the given string.&nbsp;<br/>
            &nbsp;</p>
            <p><strong>Use Sorting</strong>&nbsp;<br/>
            <strong>Algorithm:</strong>&nbsp;</p>
            <div className='output'>  1) Sort the elements. <br />
  2) Now in a loop, remove duplicates by comparing the <br />
      current character with previous character. <br />
  3)  Remove extra characters at the end of the resultant string.</div>
  <p><strong>Example:</strong>&nbsp;&nbsp;</p>
  <pre>Input string:  NooBgeek  <br />
1) Sort the characters <br />
   BeegkNoo <br />
2) Remove duplicates <br />
   BegkNo <br />
3) Remove extra characters <br />
BNegko</pre>
     <p>Note that, this method doesn’t keep the original order of the input string. For example, if we are to remove duplicates for geeksforgeeks and keep the order of characters the same, then the output should be geksfor, but the above function returns efgkos. We can modify this method by storing the original order. METHOD 2 keeps the order the same.<br/>
     &nbsp;</p>
     <div class="containers">
  <div class="line number1 index0 alt2"><code class="comment">// Java program to remove duplicates, the order of</code>
  </div>
  <div class="line number2 index1 alt1"><code class="comment">// characters is not maintained in this program</code>
  </div>
  <div class="line number3 index2 alt2">&nbsp;</div>
  <div class="line number4 index3 alt1"><code class="keywords">import</code> <code class="plain">java.util.Arrays;</code>
  </div>
  <div class="line number5 index4 alt2">&nbsp;</div>
  <div class="line number6 index5 alt1"><code class="keywords">public</code> <code class="keywords">class</code> <code
      class="plain">NooB</code></div>
  <div class="line number7 index6 alt2"><code class="plain">&#123;</code></div>
  <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">/* Method to remove duplicates in a sorted array */</code></div>
  <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">static</code> <code class="plain">String removeDupsSorted(String str)</code></div>
  <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#123;</code></div>
  <div class="line number11 index10 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
    <code class="plain">res_ind = </code><code class="value">1</code><code class="plain">, ip_ind = </code><code
      class="value">1</code><code class="plain">;</code></div>
  <div class="line number12 index11 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
  <div class="line number13 index12 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">// Character array for removal of duplicate characters</code></div>
  <div class="line number14 index13 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">char</code>
    <code class="plain">arr[] = str.toCharArray();</code></div>
  <div class="line number15 index14 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
  <div class="line number16 index15 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">/* In place removal of duplicate characters*/</code></div>
  <div class="line number17 index16 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">while</code>
    <code class="plain">(ip_ind != arr.length)</code></div>
  <div class="line number18 index17 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
  <div class="line number19 index18 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">if</code><code class="plain">(arr[ip_ind] != arr[ip_ind-</code><code class="value">1</code><code
      class="plain">])</code></div>
  <div class="line number20 index19 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#123;</code></div>
  <div class="line number21 index20 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">arr[res_ind] = arr[ip_ind];</code></div>
  <div class="line number22 index21 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">res_ind++;</code></div>
  <div class="line number23 index22 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#125;</code></div>
  <div class="line number24 index23 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">ip_ind++;</code></div>
  <div class="line number25 index24 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
  <div class="line number26 index25 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
  <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
  <div class="line number28 index27 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">str = </code><code class="keywords">new</code> <code class="plain">String(arr);</code></div>
  <div class="line number29 index28 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">return</code> <code class="plain">str.substring(</code><code class="value">0</code><code
      class="plain">,res_ind);</code></div>
  <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#125;</code></div>
  <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
  </div>
  <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">/* Method removes duplicate characters from the string</code></div>
  <div class="line number33 index32 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">This function work in-place and fills null characters</code></div>
  <div class="line number34 index33 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">in the extra space left */</code></div>
  <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">static</code> <code class="plain">String removeDups(String str)</code></div>
  <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#123;</code></div>
  <div class="line number37 index36 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">// Sort the character array</code></div>
  <div class="line number38 index37 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">char</code> <code
      class="plain">temp[] = str.toCharArray();</code></div>
  <div class="line number39 index38 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">Arrays.sort(temp);</code></div>
  <div class="line number40 index39 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">str = </code><code
      class="keywords">new</code> <code class="plain">String(temp);</code></div>
  <div class="line number41 index40 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
  <div class="line number42 index41 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">// Remove duplicates from sorted</code></div>
  <div class="line number43 index42 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">return</code>
    <code class="plain">removeDupsSorted(str);</code></div>
  <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#125;</code></div>
  <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
  </div>
 
  <div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">public</code> <code class="keywords">static</code> <code class="keywords">void</code> <code
      class="plain">main(String[] args)</code></div>
  <div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#123;</code></div>
  <div class="line number49 index48 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">String str = </code><code class="string">"NooBgeek"</code><code class="plain">;</code></div>
  <div class="line number50 index49 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">System.out.println(removeDups(str));</code></div>
  <div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#125;</code></div>
  <div class="line number52 index51 alt1"><code class="plain">&#125;</code></div>
</div>
<div className='output'>
    <p><strong>Output</strong></p>
    BNegko
</div>
        </div>
    )
}

export default Jva_Dup
